import { useSearchParams } from 'react-router-dom';

import { AppMark } from '../../components/ui/Icon';

const ADMIN_ERROR_BANNERS: Record<string, string> = {
  admin_not_authorized:
    'Your Google account is not authorized for the admin console. Contact mikehar@tombolomarine.com.',
  oidc_not_configured: 'Google sign-in is not configured on this server. Contact an operator.',
};

export function AdminLogin() {
  const [params] = useSearchParams();
  const banner = ADMIN_ERROR_BANNERS[params.get('error') ?? ''] ?? null;

  return (
    <main className="admin-auth-shell">
      <div className="admin-auth-card">
        <div className="admin-auth-mark">
          <AppMark size={48} />
        </div>
        <h1>Neomaris admin</h1>
        <p className="admin-auth-sub">
          Sign in with your <strong>@tombolomarine.com</strong> Google account.
        </p>
        {banner !== null ? <div className="admin-auth-banner">{banner}</div> : null}
        <a href="/v1/auth/admin/google/start" className="admin-google-button">
          <svg viewBox="0 0 18 18" aria-hidden="true" focusable="false">
            <path
              fill="#4285F4"
              d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
            />
            <path
              fill="#34A853"
              d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
            />
            <path
              fill="#FBBC05"
              d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
            />
            <path
              fill="#EA4335"
              d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
            />
          </svg>
          <span>Continue with Google</span>
        </a>
      </div>
    </main>
  );
}
